import { Components } from "@mui/material/styles/components";
import { FountainBlue } from "@themes:palette";

export default {
  MuiButton: {
    defaultProps: {
      disableRipple: true,
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        textTransform: "none",
        height: 35,
        borderRadius: 20,
        "&:(not([disabled]))": {
          border: `1px solid ${FountainBlue[500]} !important`,
        },
      },
    },
  } as Components["MuiButton"],
};
